export const BRANDING_PROPERTY_IDENTIFIER_COLOR =
  'BRANDINGPROPERTYIDENTIFIERCOLOR';

export const CSS_VAR_MENU_BAR_COLOR = '--menu-bar-color';
